import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import api from "../../lib/api";

/* "Read the Tokyo guide" — destination guide cards inside a trip, matched from
   the trip's stops against published Geo Content Engine articles. */
export default function TripGuideLinks({ stops = [] }) {
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    const names = [...new Set(stops.map((s) => String(s || "").split(",")[0].trim()).filter(Boolean))];
    if (!names.length) return;
    api.post("/geo-content-lookup", { names }).then((r) => {
      const seen = new Set();
      setGuides((r.data.guides || []).filter((g) => !seen.has(g.slug) && seen.add(g.slug)));
    }).catch(() => {});
  }, [JSON.stringify(stops)]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!guides.length) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-3" data-testid="trip-guide-links">
      {guides.map((g) => (
        <Link key={g.slug} to={`/explore/${g.slug}`} data-testid={`trip-guide-${g.slug.replace(/\//g, "-")}`}
          className="flex-1 min-w-[220px] max-w-sm border-2 border-[#34A853] bg-green-50/50 p-3 hover:bg-green-50 transition-colors">
          <div className="font-heading font-900 text-sm flex items-center gap-1.5 text-[#1e7e34]">
            <Compass className="w-4 h-4" /> Read the {g.name} guide
          </div>
          {g.known_for && <div className="text-xs text-zinc-600 mt-1 line-clamp-2">{g.known_for}</div>}
        </Link>
      ))}
    </div>
  );
}
